import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage from '../components/ui/LegalPage';
import COMPANY, { ROUTES } from '../config/company';
import { SMS_TERMS_BODY } from './Terms';
import { SAMPLE_MESSAGES, MARKETING_SAMPLES, OPT_IN_CONFIRMATION, HELP_REPLY, STOP_REPLY } from './SmsOptIn';

/**
 * Standalone SMS Terms & Conditions page — https://bitnexfreight.com/sms-terms
 *
 * Telnyx / TCR reviewers look for a plain, public URL that contains the SMS
 * program terms on their own. The same wording is also section 2 of the full
 * Terms & Conditions (#sms-terms); this page exists so the campaign can quote
 * a URL without a hash fragment.
 */
const SECTIONS = [
  ['SMS terms and conditions', SMS_TERMS_BODY, 'sms-terms'],
  ['How to opt in', [
    { list: [
      `Web form: enter your mobile number on our SMS opt-in page (${COMPANY.domainDisplay}${ROUTES.smsOptIn}) or Contact form (${COMPANY.domainDisplay}${ROUTES.contact}) and check the optional customer care box and/or the optional marketing box. Both boxes are unchecked by default and are not required to submit either form.`,
    ] },
    'SMS program confirmation text:',
    { quote: OPT_IN_CONFIRMATION },
  ]],
  ['Sample messages', [
    'Customer care examples:',
    ...SAMPLE_MESSAGES.map((m) => ({ quote: m })),
    'Marketing examples (sent only if you checked the marketing box):',
    ...MARKETING_SAMPLES.map((m) => ({ quote: m })),
  ]],
  ['Opt out and help', [
    'Reply STOP to any SMS to opt out. You will receive one final confirmation and no further messages:',
    { quote: STOP_REPLY },
    `Reply HELP to any message; call ${COMPANY.phoneDisplay} or email ${COMPANY.emailDisplay}:`,
    { quote: HELP_REPLY },
  ]],
  ['Privacy', [
    <p key="pv">
      Your mobile phone number and SMS opt-in consent will not be sold or shared with third parties or affiliates
      for marketing or promotional purposes. We share phone numbers only with the messaging platform that delivers our
      texts, and only so it can deliver them. Full details are in our <Link to={ROUTES.privacy}>Privacy Policy</Link>{' '}
      (section "SMS communications and consent") and our <Link to={ROUTES.terms}>Terms &amp; Conditions</Link>.
    </p>,
  ]],
  ['Contact', [
    { list: [
      
      `Phone: ${COMPANY.phoneDisplay}`,
      `Email: ${COMPANY.emailDisplay}`,
      `${COMPANY.hq.label}: ${COMPANY.legalName}, ${COMPANY.hq.line1}, ${COMPANY.hq.line2}`,
    ] },
  ]],
];

export default function SmsTerms() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="SMS Terms & Conditions"
      lede={`The terms of the ${COMPANY.sms.programName} text-message program: what you receive, how often, what it costs, and how to stop.`}
      sections={SECTIONS}
    />
  );
}
